import {LocalizedDictionary} from '../Translator';

export default {
  "DD": "DD",
  "Discontinued": "Descatalogado",
  "Spare part list": "Lista de piezas de recambio",
  "Download Excel": "Descargar Excel",
  "Recent search list": "Lista de búsquedas recientes",
  "No data": "Sin datos",
  "spare part": "recambio",
  "none": "ninguno",
  "no value": "sin valor",
  "No results found": "No se han encontrado resultados",
  "Spare parts for": "Piezas de recambio para",
  "Could not load cumulated data": "No se han podido cargar los datos acumulados",
  "commissioning part": "puesta en servicio",
  "wear part": "pieza de desgaste",
  "Search": "Buscar en",
  "Tk": "Tk",
  "Spare part number": "Número de pieza de recambio",
  "drawing": "dibujo",
  "Products for": "Productos para",
  "Available": "Disponible",
  "MM": "MM",
  "The entered order code is invalid": "El código de producto introducido no es válido.",
  "Recommended": "Recomendado",
  "No data available for the entered search parameters": "No hay datos disponibles para los parámetros de búsqueda introducidos",
  "Search spare parts": "Buscar piezas de recambio",
  "Order code / product root / serial number": "Código de producto / raíz del producto / número de serie",
  "Characteristic": "Característica",
  "Please enter an order code": "Introduzca un código de producto",
  "Regarding quality- and security-aspects Endress+Hauser strongly recommends the exclusive use of genuine Endress+Hauser spare parts. The instrument may only be maintained and repaired by qualified personnel. The device documentation, applicable standards and legal requirements as well as any certificates have to be observed!": "En cuanto a los aspectos de calidad y seguridad, Endress+Hauser recomienda encarecidamente el uso exclusivo de piezas de repuesto auténticas Endress+Hauser. \nEl mantenimiento y la reparación del aparato sólo deben ser efectuados por personal cualificado. \nDeben observarse las normas y requisitos legales aplicables a la documentación del dispositivo, así como los certificados correspondientes.",
  "Maintenance advice": "Consejos de mantenimiento",
  "Mo.": "Mo.",
  "For which product(s) can my spare part be used? Filling in the spare part order code (e.g. 71002865 or XPD0024) shows the relevant devices this spare part can be used in.": "¿Para qué productos se puede utilizar mi recambio? Rellenando el código de producto de la pieza de recambio (por ejemplo 71002865 o XPD0024) se muestran los dispositivos relevantes en los que se puede utilizar esta pieza de recambio.",
  "tool": "herramienta",
  "Production numbers": "Cifras de producción",
  "New alternative": "Nueva alternativa",
  "There are no items selected. Please use the checkboxes to make your selection": "No hay artículos seleccionados. Utilice las casillas para hacer su selección",
  "Service segmentation": "Segmentación de los servicios",
  "Seg": "Seg",
  "Valid": "Válido",
  "Pos": "Pos",
  "Value": "Valor",
  "service segmentation 2": "Piezas que requieren conocimientos básicos. La participación satisfactoria en la formación básica E+H es un requisito previo.",
  "Phase out date": "Fecha de retirada",
  "service segmentation 1": "Piezas que requieren conocimientos básicos.",
  "Which spare parts are available for my product? Filling in the order code (e.g. FTC260-AA2A1 or PMC51-BA21JB1CGBTDJB) or the product id (e.g. FTC260 or 83F50) shows the relevant spare parts.": "¿Qué piezas de recambio hay disponibles para mi producto? Al rellenar el código de producto (por ejemplo, FTC260-AA2A1 o PMC51-BA21JB1CGBTDJB) o la identificación del producto (por ejemplo, FTC260 o 83F50) se muestran las piezas de recambio correspondientes.",
  "Set filter": "Fijar filtro",
  "Search date": "Fecha de búsqueda",
  "Group": "Grupo",
  "Warning": "Advertencia",
  "Description": "Descripción",
  "Cancel": "Cancelar",
  "service segmentation 4": "Piezas para reparar en fábrica. El conocimiento experto es obligatorio.",
  "service segmentation 3": "Piezas que requieren conocimientos especializados. La participación satisfactoria en la formación avanzada de E+H es un requisito previo.",
  "Drawing Position Number": "Número de posición del dibujo",
  "Spare parts search": "Búsqueda de piezas de recambio",
  "Confirm": "Confirme",
  "Ordercode too short": "Código de pedido demasiado corto",
  "Product status": "Estado del producto",
  "Open": "Abrir",
  "Clear": "Claro",
  "PDF file with assembly instructions": "Archivo PDF con instrucciones de montaje",
  "Search products": "Buscar productos",
  "Export": "Exportar",
  "Production date": "Fecha de producción",
  "Order stop": "Parada de pedidos",
  "Calibration until": "Calibración hasta",
  "PDF file with compatibility information": "Archivo PDF con información sobre compatibilidad",
  "Add selection to cart": "Añadir selección a la cesta",
  "Mounting advices": "Consejos de montaje",
  "Recommended parts only": "Sólo piezas recomendadas",
  "not applicable": "no aplicable",
  "accessories": "accesorios",
  "Cumulative spare parts list": "Lista acumulativa de piezas de recambio",
  "YYYY": "AAAA",
  "Title": "Título",
  "Error": "Error",
  "Ordercode too long": "Código de pedido demasiado largo",
  "Functions": "Funciones",
  "Rec": "Rec",
  "Type": "Tipo",
  "Spare sensor until": "Sensor de repuesto hasta",
  "Spare parts until": "Piezas de recambio hasta",
  "Filter": "Filtro",
  "Check all": "Comprobar todo",
  "Order code": "Código de producto",
  "Repair until": "Reparación hasta",
  "Tag": "Etiqueta",
  "Ok": "Ok",
  "Category code": "Código de categoría",
  "Phase out": "Eliminación progresiva",
  'Compatibility advices': 'Documentos adicionales',
  'Co.': 'Doc. adic.',
} as LocalizedDictionary;
